@if (showBanner()) {
	<div
		style="width:100%;">
		<iframe
			style="width:100%; height:100%; min-height: 160px; border:0;" 
			allowfullscreen
      		[src]="safeUrl">
		</iframe>
	</div>
}